import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'are_worker_exposures_noise_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'are_worker_exposures_noise_line_legal_requirements',
  name: 'Are worker exposures to noise in line with legal requirements?',
  description:
    "Worker exposures take into account the noise level and time exposures and are generally measured with 'dosimetry'.  ",
  meta: {
    slcpMeta: {
      key: 'hs-gen-5',
      number: 'HS-GEN-13',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31280,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
